module.exports = __webpack_public_path__ + "img/minus.7cda9856.svg";